import Model from '../Model';
export default class AccessToken extends Model {
  token() {
    return Model.attribute('token').call(this);
  }
  userId() {
    return Model.attribute('userId').call(this);
  }
  title() {
    return Model.attribute('title').call(this);
  }
  type() {
    return Model.attribute('type').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  lastActivityAt() {
    return Model.attribute('lastActivityAt', Model.transformDate).call(this);
  }
  lastIpAddress() {
    return Model.attribute('lastIpAddress').call(this);
  }
  device() {
    return Model.attribute('device').call(this);
  }
  isCurrent() {
    return Model.attribute('isCurrent').call(this);
  }
  isSessionToken() {
    return Model.attribute('isSessionToken').call(this);
  }
}
flarum.reg.add('core', 'common/models/AccessToken', AccessToken);